<!-- src/apps/secret/components/conceal/landing/LandingSectionHeader.vue -->

<script setup lang="ts">
  defineProps<{
    /** Section index label, e.g. "02." */
    number: string;
    /** Already-translated section title */
    title: string;
  }>();
</script>

<template>
  <div
    class="flex items-center gap-3 border-b border-day-line px-5 py-6 dark:border-white/[0.07] sm:px-8">
    <span
      class="inline-block size-1.5 shrink-0 rounded-full bg-brand-500 shadow-[0_0_8px_var(--color-brand-500)]"
      aria-hidden="true" ></span>
    <span class="font-mono text-[11px] font-semibold tracking-[0.12em] text-brand-600 dark:text-brand-400">{{ number }}</span>
    <span
      class="h-3 w-px bg-day-line-2 dark:bg-white/[0.13]"
      aria-hidden="true" ></span>
    <h2
      class="font-mono text-[11px] font-semibold uppercase tracking-[0.14em] text-day-ink-muted dark:text-night-ink-muted">
      {{ title }}
    </h2>
  </div>
</template>
